module.exports = __webpack_public_path__ + "img/avatarArtboard-5.2718a054.svg";